export default __webpack_public_path__ + "static/pen-22b569e4e27751e84837c80a58777fb0.png";